document.addEventListener("DOMContentLoaded", function() {

	var $ = jQuery.noConflict(),
			pageUrl = window.location.href;

    /**
	 * Mobile Menu Toggle
	 */
	if ($("body").hasClass("menu-open")) {
		$('body').removeClass("menu-open");
	} else {
		$('body').toggleClass("menu-open");
	}

	$('body').removeClass("menu-open");


	$('.header-nav-overlay').on('click', function() {
		$('body').removeClass("menu-open");
	});

	$(window).resize(function () {
		$('.tfa-header-menu-container .navbar-nav input').prop('checked', false);
	});

	$('.tfa-header-menu-container .navbar-nav>.menu-item a').each(function() {
		var target = $(this).attr('href');
		if( pageUrl === target ) {
			$(this).parent('.nav-item').addClass('menu-item-current');
		} else {
			$(this).parent('.nav-item').removeClass('menu-item-current');
		}
	});

    	/**
	 * Switcher Dark Mode
	 */
	const darkTheme = "dark-theme";
	const darkThemeSetUp = () => {
		if (getCurrentTheme() === "dark") {
			document.getElementById("toggleBtn").checked = true;
		} else {
			document.getElementById("toggleBtn").checked = false;
		}
	};
	const getCurrentTheme = () => document.body.classList.contains(darkTheme) ? "dark" : "light";
	const selectedTheme = localStorage.getItem("selected-theme");
	if (selectedTheme === "dark") {
		document.body.classList[selectedTheme === "dark" ? "add" : "remove"](
			darkTheme
		);
		darkThemeSetUp();
	}
	const themeButton = document.getElementById("toggleBtn");

	if ($("body").hasClass("light-dark")) {
		// console.log('btn active');
		$(".switcher-darkmode").css("display","block");

		themeButton.addEventListener("change", () => {
			document.body.classList.toggle(darkTheme);
			localStorage.setItem("selected-theme", getCurrentTheme());
			darkThemeSetUp();
		});
		
	} else {
		// console.log('btn not active');
		$(".switcher-darkmode").css("display","none");
	}

	/**
	 * Switching Cart
	 */
	if ($("body").hasClass("woo-cart")) {
		$(".wp-block-woocommerce-mini-cart").css({"display":"flex","opacity":"1"});
	}
	else {
		$(".wp-block-woocommerce-mini-cart").css("display","none");
	}

	/**
	 * Switching Account Btn
	 */
	if ($("body").hasClass("woo-account")) {
		$(".block-account").css({"display":"flex","opacity":"1"});
	}
	else {
		$(".block-account").css("display","none");
	}

	/**
	 * Switching Flags Btn
	 */
	if ($("body").hasClass("menu-flags")) {
		$(".block-polylang").css({"display":"flex","opacity":"1"});
	}
	else {
		$(".block-polylang").css("display","none");
	}

	if ( $("body nav.header-nav").hasClass("megamenu") ) { 
		$(".navbar-toggler-btn").css({"display":"none"});
	} else {
		$(".navbar-toggler-btn").css({"display":"block"});
	}
    
});